module.exports = __webpack_public_path__ + "img/bg_banner.284b259d.png";